import { Location, LocationCreate, LocationUpdate } from "../../api";
import { LocationEntry } from "../../types";

export const locationsCreateToExternal = (
  entry: LocationEntry,
): LocationCreate => ({
  address: entry.address,
  city: entry.city,
  country: entry.country,
  latitude: entry.latitude,
  longitude: entry.longitude,
  contact_person_name: entry.contactPersonName,
  contact_phone_number: entry.contactPersonPhone,
});

export const locationsUpdateToExternal = (
  entry: Partial<LocationEntry>,
): LocationUpdate => ({
  address: entry.address,
  city: entry.city,
  country: entry.country,
  latitude: entry.latitude,
  longitude: entry.longitude,
  contact_person_name: entry.contactPersonName,
  contact_phone_number: entry.contactPersonPhone,
});

export const locationsFromExternalList = (entry: Location): LocationEntry => ({
  id: entry.id,
  country: entry.country,
  city: entry.city,
  address: entry.address,
  latitude: entry.latitude,
  longitude: entry.longitude,
  contactPersonName: entry.contact_person_name,
  contactPersonPhone: entry.contact_phone_number,
  commentsCount: entry.comments_count,
});
